<template>
  <div class="terms-container">
    <div class="terms-content">
      <header class="terms-header">
        <h1>服务条款</h1>
        <p class="last-updated">最后更新时间：2025年7月</p>
      </header>

      <div class="terms-body">
        <section class="terms-section">
          <h2>1. 接受条款</h2>
          <p>欢迎使用我们的TikTok API集成应用（以下简称"本应用"）。通过访问或使用本应用，您同意受本服务条款（以下简称"条款"）的约束。如果您不同意这些条款，请不要使用本应用。</p>
        </section>

        <section class="terms-section">
          <h2>2. 服务描述</h2>
          <p>本应用提供与TikTok平台集成的服务，包括但不限于：</p>
          <ul>
            <li>TikTok账号授权和登录服务</li>
            <li>视频内容管理和上传功能</li>
            <li>社交媒体数据分析和洞察</li>
            <li>用户互动和内容创作工具</li>
            <li>TikTok API数据同步和管理</li>
          </ul>
        </section>

        <section class="terms-section">
          <h2>3. 用户账户</h2>
          <h3>3.1 账户注册</h3>
          <ul>
            <li>您必须提供准确、完整和最新的信息</li>
            <li>您有责任维护账户信息的准确性</li>
            <li>您有责任保护账户密码和TikTok授权信息的安全</li>
            <li>您必须拥有有效的TikTok账户才能使用本服务</li>
          </ul>

          <h3>3.2 账户使用</h3>
          <ul>
            <li>每个用户只能注册一个账户</li>
            <li>不得与他人共享账户信息</li>
            <li>如发现账户被盗用，请立即通知我们</li>
            <li>您同意遵守TikTok平台的使用条款</li>
          </ul>
        </section>

        <section class="terms-section">
          <h2>4. 使用规则</h2>
          <h3>4.1 禁止行为</h3>
          <p>用户在使用本应用时，不得：</p>
          <ul>
            <li>上传、发布违法、有害、威胁、辱骂、诽谤、粗俗、色情或其他令人反感的内容</li>
            <li>侵犯他人的知识产权、隐私权或其他合法权益</li>
            <li>传播病毒、恶意软件或其他有害代码</li>
            <li>干扰或破坏本应用或TikTok平台的正常运行</li>
            <li>违反任何适用的法律法规或TikTok平台政策</li>
            <li>滥用TikTok API或进行恶意爬虫行为</li>
            <li>未经授权访问或使用他人的TikTok账户</li>
          </ul>

          <h3>4.2 内容要求</h3>
          <ul>
            <li>用户对其发布的内容承担全部责任</li>
            <li>我们保留删除违规内容的权利</li>
            <li>重复违规可能导致账户被暂停或终止</li>
            <li>您必须拥有上传内容的合法权利</li>
          </ul>
        </section>

        <section class="terms-section">
          <h2>5. TikTok平台集成</h2>
          <h3>5.1 API使用</h3>
          <ul>
            <li>本应用通过TikTok官方API与平台集成</li>
            <li>您授权我们访问您TikTok账户的特定信息</li>
            <li>我们仅访问您明确授权的数据范围</li>
            <li>我们遵循TikTok API的使用限制和速率限制</li>
          </ul>

          <h3>5.2 数据同步</h3>
          <ul>
            <li>您的TikTok数据将根据授权范围进行同步</li>
            <li>您可以随时撤销TikTok授权</li>
            <li>我们不会存储您的TikTok登录凭据</li>
            <li>数据同步遵循TikTok平台的隐私政策</li>
          </ul>
        </section>

        <section class="terms-section">
          <h2>6. 知识产权</h2>
          <h3>6.1 我们的权利</h3>
          <ul>
            <li>本应用及其所有内容受知识产权法保护</li>
            <li>我们保留所有未明确授予用户的权利</li>
            <li>TikTok相关商标和标识归TikTok所有</li>
          </ul>

          <h3>6.2 用户内容</h3>
          <ul>
            <li>用户保留其创建内容的所有权</li>
            <li>用户授予我们使用、修改、显示和分发用户内容的非排他性许可</li>
            <li>用户确保拥有上传内容的合法权利</li>
          </ul>
        </section>

        <section class="terms-section">
          <h2>7. 隐私保护</h2>
          <p>我们重视您的隐私，请参阅我们的<a href="/privacy-policy" class="link">隐私政策</a>了解我们如何收集、使用和保护您的个人信息。</p>
        </section>

        <section class="terms-section">
          <h2>8. 免责声明</h2>
          <h3>8.1 服务可用性</h3>
          <ul>
            <li>本应用按"现状"提供，不保证无错误或不间断</li>
            <li>我们不对服务中断、数据丢失或其他技术问题承担责任</li>
            <li>TikTok平台服务中断可能影响本应用功能</li>
          </ul>

          <h3>8.2 第三方服务</h3>
          <ul>
            <li>本应用依赖TikTok平台服务</li>
            <li>我们不对TikTok平台的内容或可用性承担责任</li>
            <li>TikTok平台政策变更可能影响本应用功能</li>
          </ul>
        </section>

        <section class="terms-section">
          <h2>9. 赔偿</h2>
          <p>用户同意就因违反本条款而产生的任何索赔、损失或损害赔偿我们及我们的关联公司、董事、员工和代理人。</p>
        </section>

        <section class="terms-section">
          <h2>10. 服务变更和终止</h2>
          <h3>10.1 服务变更</h3>
          <ul>
            <li>我们可能随时修改或停止服务的任何部分</li>
            <li>我们将尽力提前通知重大变更</li>
            <li>TikTok API变更可能导致服务调整</li>
          </ul>

          <h3>10.2 账户终止</h3>
          <ul>
            <li>我们可能因违反条款而终止用户账户</li>
            <li>用户可以随时删除账户</li>
            <li>账户终止后，相关数据将在30天内删除</li>
          </ul>
        </section>

        <section class="terms-section">
          <h2>11. 争议解决</h2>
          <h3>11.1 适用法律</h3>
          <p>本条款受中华人民共和国法律管辖。</p>

          <h3>11.2 争议处理</h3>
          <ul>
            <li>优先通过友好协商解决争议</li>
            <li>协商不成的，提交有管辖权的人民法院解决</li>
          </ul>
        </section>

        <section class="terms-section">
          <h2>12. 条款修改</h2>
          <p>我们可能会不时修改本条款。修改后的条款将在本应用中发布，继续使用服务即表示接受修改后的条款。</p>
        </section>

        <section class="terms-section">
          <h2>13. 联系我们</h2>
          <p>如果您对本服务条款有任何疑问，请通过以下方式联系我们：</p>
          <ul>
            <li>邮箱：beiniu@beiniu.org</li>
            <li>地址：浙江省杭州市钱塘区下沙街道元创公园3幢709室</li>
            <!-- <li>电话：188-6880-8868</li> -->
          </ul>
        </section>
      </div>

      <footer class="terms-footer">
        <router-link to="/" class="btn-back">返回首页</router-link>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService',
  mounted() {
    document.title = '服务条款 - TikTok集成应用'
  }
}
</script>

<style scoped>
.terms-container {
  min-height: 100vh;
  background: #f8f9fa;
  padding: 2rem 1rem;
}

.terms-content {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.terms-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 3rem 2rem;
  text-align: center;
}

.terms-header h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.last-updated {
  opacity: 0.9;
  font-size: 0.9rem;
}

.terms-body {
  padding: 2rem;
}

.terms-section {
  margin-bottom: 2rem;
}

.terms-section h2 {
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #667eea;
}

.terms-section h3 {
  color: #555;
  font-size: 1.2rem;
  margin: 1.5rem 0 0.5rem 0;
}

.terms-section p {
  line-height: 1.6;
  color: #666;
  margin-bottom: 1rem;
}

.terms-section ul {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.terms-section li {
  line-height: 1.6;
  color: #666;
  margin-bottom: 0.5rem;
}

.link {
  color: #667eea;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.terms-footer {
  padding: 2rem;
  text-align: center;
  border-top: 1px solid #eee;
}

.btn-back {
  display: inline-block;
  padding: 0.75rem 2rem;
  background: #667eea;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 500;
  transition: background-color 0.3s;
}

.btn-back:hover {
  background: #5a6fd8;
}

@media (max-width: 768px) {
  .terms-container {
    padding: 1rem 0.5rem;
  }
  
  .terms-header {
    padding: 2rem 1rem;
  }
  
  .terms-header h1 {
    font-size: 2rem;
  }
  
  .terms-body {
    padding: 1.5rem;
  }
}
</style> 